import { render, staticRenderFns } from "./RightmoveComponent.vue?vue&type=template&id=5900af3c&scoped=true&"
import script from "./RightmoveComponent.vue?vue&type=script&lang=js&"
export * from "./RightmoveComponent.vue?vue&type=script&lang=js&"
import style0 from "./RightmoveComponent.vue?vue&type=style&index=0&id=5900af3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5900af3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VCol,VIcon,VRow,VSimpleTable})
